// @ts-nocheck
import ReCAPTCHA from "react-google-recaptcha";

const InvisibleReCaptcha = ({
  recaptchaRef,
  badge
}: Partial<{
  // eslint-disable-next-line no-undef
  recaptchaRef?: MutableRefObject<HTMLInputElement>;
  badge?: string;
}>) => {
  if (!process.env.RECAPTCHA_INVISIBLE_SITE_KEY) return null;

  return (
    <ReCAPTCHA
      size="invisible"
      ref={recaptchaRef}
      sitekey={process.env.RECAPTCHA_INVISIBLE_SITE_KEY}
      badge={badge}
    />
  );
};

export default InvisibleReCaptcha;
